import ErrorRequestFailed from './ErrorRequestFailed.js'
import ErrorRequestFailedLocally from './ErrorRequestFailedLocally.js'

import * as log from 'loglevel'

class ErrorFactory {
  /**
   * Creates a formated Error object from normal js errors.
   * @param {*} error as js Error
   */
  make (errors, message) {
    log.debug(errors)
    if (!errors) {
      return new ErrorRequestFailedLocally(message)
    }
    if (this.isSingleError(errors)) {
      return new ErrorRequestFailed([errors], message)
    }
    return new ErrorRequestFailed(errors, message)
  }

  isSingleError (errors) {
    return !Array.isArray(errors)
  }
}

export default ErrorFactory



// WEBPACK FOOTER //
// ./src/models/ErrorFactory.js